"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGallery = void 0;
var _box = require("@oneloop/box");
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _excluded = ["text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var ButtonGallery = exports.ButtonGallery = function ButtonGallery(_ref) {
  var text = _ref.text,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    __css: {
      padding: '6px 12px',
      color: '#FFF',
      borderRadius: '32px',
      background: _theme["default"].colors.secondary,
      border: '1px solid #A2D4E5',
      fontFamily: 'Nunito Sans',
      fontSize: '12px',
      fontWeight: '600',
      cursor: 'pointer',
      ':hover': {
        background: '#A2D4E5',
        color: _theme["default"].colors.secondary
      },
      ':active': {
        color: _theme["default"].colors.secondaryHover,
        borderColor: _theme["default"].colors.secondary
      }
    }
  }, props), text);
};